import { createContext, ReactNode, useContext, useState } from 'react';

const MediaPreferencesContext = createContext<{
    isShowingSubtitles: boolean;
    setIsShowingSubtitles: (b: boolean) => void;
}>({
    isShowingSubtitles: true,
    setIsShowingSubtitles: () => null,
});

export function useMediaPreferences() {
    return useContext(MediaPreferencesContext);
}

export default function MediaPreferencesProvider({
    children,
}: {
    children: ReactNode;
}) {
    const [isShowingSubtitles, setIsShowingSubtitles] = useState(true);
    return (
        <MediaPreferencesContext.Provider
            value={{ isShowingSubtitles, setIsShowingSubtitles }}
        >
            {children}
        </MediaPreferencesContext.Provider>
    );
}
